export default class SlidesToggle {
  static init(node, countOfSteps) {
    if (!node) {
      return null;
    }
    return new SlidesToggle(node, countOfSteps);
  }

  constructor(node, countOfSteps) {
    this.selectors = {
      prevArrowSelector: '[data-smart-apartment-arrow-prev]',
      nextArrowSelector: '[data-smart-apartment-arrow-next]',
    };

    this.els = {
      arrowsContainer: node,
    };

    this.countOfSteps = countOfSteps;

    this.addEventListeners();
  }

  addEventListeners() {
    const { prevArrowSelector, nextArrowSelector } = this.selectors;
    const { arrowsContainer } = this.els;

    arrowsContainer.addEventListener('click', (event) => {
      const section = event.target.closest('section');
      const currentTabNumber = section.dataset.active;
      let nextTabNumber;

      if (event.target.closest(nextArrowSelector)) {
        nextTabNumber =
          currentTabNumber === this.countOfSteps
            ? this.countOfSteps
            : +currentTabNumber + 1;
      } else if (event.target.closest(prevArrowSelector)) {
        nextTabNumber = currentTabNumber === '1' ? '1' : +currentTabNumber - 1;
      }

      if (nextTabNumber) {
        section.dataset.active = nextTabNumber;
      }
    });
  }
}
